import { useEffect } from "react";
import Toast from "./Toast";
import { useUserMessages } from "../store/user";

/**
 * Global learner feedback. Renders the newest success/error message from the
 * user store as a toast. Mounted once in UserNavBar2 so every learner page gets
 * consistent error display without per-page wiring.
 */
const UserFeedback = () => {
  const { successMessage, errorMessage, clearMessage } = useUserMessages();
  const message = errorMessage || successMessage;
  const isSuccess = Boolean(successMessage) && !errorMessage;

  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(() => clearMessage(), 5000);
    return () => clearTimeout(timer);
  }, [message, clearMessage]);

  if (!message) return null;
  return <Toast message={message} onClose={clearMessage} isSuccess={isSuccess} />;
};

export default UserFeedback;
